import {ReactComponent as Icon} from '@image/icon_warning.svg';

const IconWarning = () => {
    return   <Icon />;
};

export default IconWarning;